// extracted by mini-css-extract-plugin
module.exports = {"typography":"categoryFaqItem_typography__gCI8k","answer":"categoryFaqItem_answer__hV6Th"};